// extracted by mini-css-extract-plugin
export default {"card":"Login_card__oPgS2","submitBtnContainer":"Login_submitBtnContainer__1S9QU","loginTableContainer":"Login_loginTableContainer__31rNX"};